var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.0386H21V9.99707H12V13.9971H17.6515C16.827 16.3256 14.6115 17.9971 12 17.9971C8.6865 17.9971 6 15.3106 6 11.9971C6 8.68357 8.6865 5.99707 12 5.99707C13.5295 5.99707 14.921 6.57407 15.9805 7.51657L18.809 4.68807C17.023 3.02357 14.634 1.99707 12 1.99707C6.4775 1.99707 2 6.47457 2 11.9971C2 17.5196 6.4775 21.9971 12 21.9971C17.5225 21.9971 22 17.5196 22 11.9971C22 11.3266 21.931 10.6721 21.8055 10.0386Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15332 7.34257L6.43882 9.75207C7.32782 7.55107 9.48082 5.99707 12.0003 5.99707C13.5298 5.99707 14.9213 6.57407 15.9808 7.51657L18.8093 4.68807C17.0233 3.02357 14.6343 1.99707 12.0003 1.99707C8.15932 1.99707 4.82832 4.16557 3.15332 7.34257Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 21.9969C14.5832 21.9969 16.9302 21.0084 18.7047 19.4009L15.6097 16.7819C14.5721 17.5715 13.3039 17.9983 12.0002 17.9969C9.39916 17.9969 7.19066 16.3384 6.35866 14.0239L3.09766 16.5364C4.75266 19.7749 8.11366 21.9969 12.0002 21.9969Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.0386H21V9.99707H12V13.9971H17.6515C17.2571 15.1053 16.5467 16.0737 15.608 16.7826L15.6095 16.7816L18.7045 19.4006C18.4855 19.5996 22 16.9971 22 11.9971C22 11.3266 21.931 10.6721 21.8055 10.0386Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f4e1ec52de64d1f185fb1ca34be84e49.svg";
export { ForwardRef as ReactComponent };